<template>
  <div id="user-profile">
    <v-container fluid class="py-8">
      <!-- Alert Section -->
      <v-row>
        <v-col cols="12">
          <User_Alert />
        </v-col>
      </v-row>

      <!-- Main Content -->
      <v-row>
        <!-- Profile Card -->
        <v-col cols="12" md="4">
          <v-card class="profile-card">
            <!-- Profile Header -->
            <div class="profile-header">
              <div class="profile-avatar-wrapper">
                <v-avatar size="160" class="profile-avatar">
                  <v-img
                    v-if="users.personnel_temporary_pic"
                    :src="'/HRvecfiles/' + users.personnel_temporary_pic"
                  />
                  <v-img
                    v-else
                    src="/HRvecfiles/blank-human-image.png"
                  />
                </v-avatar>
                <v-btn
                  v-if="users.personnel_temporary_pic"
                  icon
                  small
                  color="error"
                  class="delete-pic-btn"
                  @click="personnelPicDelete()"
                >
                  <v-icon small>mdi-delete</v-icon>
                </v-btn>
              </div>
              
              <div class="profile-info text-center mt-6">
                <h3 class="font-weight-medium mb-1">
                  {{ users.title_s }}{{ users.frist_name }} {{ users.last_name }}
                </h3>
                <p class="grey--text text--darken-1 mb-1">
                  {{ users.id_card }}
                </p>
                <p class="primary--text">
                  {{ users.college_name }}
                </p>
              </div>
            </div>

            <v-divider class="my-4" />

            <!-- Action Buttons -->
            <div class="profile-actions px-6 pb-6">
              <v-btn
                block
                outlined
                color="primary"
                class="mb-3"
                @click="personnelPicUpdate()"
              >
                <v-icon left small>mdi-image-edit</v-icon>
                แก้ไขรูปโปรไฟล์
              </v-btn>

              <v-btn
                block
                outlined
                color="primary"
                class="mb-3"
                @click="passwordUpdate()"
              >
                <v-icon left small>mdi-lock-reset</v-icon>
                แก้ไขรหัสผ่าน
              </v-btn>

              <v-btn
                block
                outlined
                :color="String(users_etc.personnel_etc_pass_api).length > 4 ? 'success' : 'grey'"
                class="mb-3"
                @click="permitSystem()"
              >
                <v-icon left small>
                  {{ String(users_etc.personnel_etc_pass_api).length > 4 ? 'mdi-shield-check' : 'mdi-shield-off' }}
                </v-icon>
                {{ String(users_etc.personnel_etc_pass_api).length > 4 ? 'อนุญาตแล้ว' : 'อนุญาตการเข้าถึง' }}
              </v-btn>
            </div>
          </v-card>

          <!-- Info Card (Teacher) -->
          <v-card v-if="users.user_status === 'teacher'"  class="mt-4 info-card">
            <v-card-text>
              <h4 class=" font-weight-medium mb-3">
                ข้อมูลในระบบ
              </h4>
              <p class="mb-2">
                หากยังไม่เป็นปัจจุบันให้รอการปรับปรุงจากส่วนกลาง
              </p>
              <v-divider class="my-3" />
              <div class="">
                <p class="mb-1"><strong>ภาระกิจหลัก 4 ระบบ:</strong></p>
                <p class="mb-1">1. ระบบย้ายข้าราชการครู</p>
                <p class="mb-1">2. ระบบย้ายสายบริหาร</p>
                <p class="mb-1">3. ระบบอัตรากำลัง</p>
                <p class="mb-0">4. ระบบประเมินครูผู้ช่วย</p>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- Information Card -->
        <v-col cols="12" md="8">
          <v-card  class="info-card">
            <v-card-title class="d-flex align-center pb-0">
              <v-icon class="mr-2">mdi-account-details</v-icon>
              <span class="font-weight-medium">ข้อมูลส่วนบุคคล</span>
            </v-card-title>

            <v-card-text class="pt-4">
              <!-- Status Alert -->
              <v-alert
                v-if="users.status_appove === 'wait'"
                text
                dense
                color="warning"
                border="left"
                class="mb-4"
              >
                <span class="">
                  ข้อมูลของท่านอยู่ระหว่างการตรวจสอบในระหว่างการย้ายรอบที่ผ่านมา
                </span>
              </v-alert>

              <!-- Transfer Application Section (Teacher) -->
              <div v-else-if="users.user_status === 'teacher'">
                <v-card
                  v-if="periods.period_enable === '1' && periods.period_type === 'teacher'"
                  outlined
                  class="mb-4"
                >
                  <v-card-text>
                    <div class="text-center">
                      <h4 class="font-weight-medium mb-3">
                        การยื่นย้ายสายการสอน
                      </h4>
                      <p class="mb-4">
                        ครั้งที่ {{ periods.period_times }} 
                        ระหว่างวันที่ {{ formatDateToThaiIntl(periods.period_start) }} - 
                        {{ formatDateToThaiIntl(periods.period_stop) }}
                      </p>

                      <div v-if="users.date_app_now === ''">
                        <v-alert type="error" text class="mb-0">
                          <span class="">
                            ให้งานบุคลากรสถานศึกษาของท่านดำเนินการเกี่ยวกับวันที่ปฏิบัติงาน
                          </span>
                        </v-alert>
                      </div>

                      <div v-else>
                        <v-alert
                          v-if="users.type_personnel === 'local_dev' && get_gov_Age_year < 4"
                          type="error"
                          text
                        >
                          <span class="">
                            ท่านสามารถดำเนินการยื่นย้ายได้กรณีที่ปฏิบัติงาน ณ สถานศึกษาปัจจุบันเป็นเวลาไม่น้อยกว่า 4 ปี
                          </span>
                        </v-alert>

                        <v-btn
                          v-else
                          x-large
                          color="primary"
                          elevation="0"
                          class="px-8"
                          to="/transference_personnel"
                          @click="timeCheck()"
                        >
                          <v-icon left>mdi-file-document-edit</v-icon>
                          ยื่นคำร้องขอย้าย
                        </v-btn>
                      </div>
                    </div>
                  </v-card-text>
                </v-card>
              </div>

              <!-- Transfer Application Section (Director) -->
              <div v-else-if="users.user_status === 'director'">
                <v-card
                  v-if="periodsmanage_di.period_enable === '1'"
                  outlined
                  class="mb-4"
                >
                  <v-card-text>
                    <v-btn
                      v-if="periodsmanage_di.period_quality_case === '1'"
                      block
                      large
                      color="info"
                      elevation="0"
                      class="mb-3"
                      to="/transference_manage_d"
                    >
                      <v-icon left>mdi-file-document-edit</v-icon>
                      การย้ายสายบริหาร (เพื่อพัฒนาคุณภาพการศึกษา)
                    </v-btn>

                    <v-btn
                      v-if="periodsmanage_di.period_normal_case === '1'"
                      block
                      large
                      color="primary"
                      elevation="0"
                      to="/transference_manage"
                    >
                      <v-icon left>mdi-file-document-edit</v-icon>
                      การย้ายสายบริหาร (กรณีปกติ)
                    </v-btn>
                  </v-card-text>
                </v-card>
              </div>

              <!-- Transfer Application Section (SE Director) -->
              <div v-else-if="users.user_status === 'se_director'">
                <v-card
                  v-if="periodsmanage_sedi.period_enable === '1'"
                  outlined
                  class="mb-4"
                >
                  <v-card-text>
                    <v-btn
                      block
                      large
                      color="primary"
                      elevation="0"
                      to="/transference_manage"
                    >
                      <v-icon left>mdi-file-document-edit</v-icon>
                      การย้ายสายบริหาร (กรณีปกติ)
                    </v-btn>
                  </v-card-text>
                </v-card>
              </div>

              <!-- Agency Info -->
              <v-alert
                text
                dense
                color="info"
                border="left"
                class="mb-4"
              >
                <div class="d-flex align-center">
                  <v-icon class="mr-2">mdi-domain</v-icon>
                  <span class="">สังกัด {{ users.agencys }}</span>
                </div>
              </v-alert>

              <!-- Personal Information Sections -->
              <v-row>
                <!-- Left Column -->
                <v-col cols="12" md="6">
                  <div class="info-section">
                    <!-- Position Info -->
                    <div class="info-item">
                      <v-icon small class="mr-2 grey--text">mdi-badge-account</v-icon>
                      <div class="flex-grow-1">
                        <p class="grey--text mb-0">เลขที่ตำแหน่ง</p>
                        <p class="mb-0">{{ users.id_position }}</p>
                      </div>
                      <div class="ml-4">
                        <p class="grey--text mb-0">ตำแหน่ง</p>
                        <p class="mb-0">{{ users.position_name }}</p>
                      </div>
                    </div>

                    <v-divider class="my-3" />

                    <!-- Education Info -->
                    <div class="info-item">
                      <v-icon small class="mr-2 grey--text">mdi-school</v-icon>
                      <div class="flex-grow-1">
                        <p class="grey--text mb-0">คุณวุฒิ</p>
                        <p class="mb-0">{{ users.ed_abb }}</p>
                      </div>
                      <div class="ml-4">
                        <p class="grey--text mb-0">สาขาวิชาเอก</p>
                        <p class="mb-0">{{ users.ed_name }}</p>
                      </div>
                    </div>

                    <v-divider class="my-3" />

                    <!-- Rank Info -->
                    <div class="info-item">
                      <v-icon small class="mr-2 grey--text">mdi-certificate</v-icon>
                      <div class="flex-grow-1">
                        <p class="grey--text mb-0">วิทยฐานะ</p>
                        <p class="mb-0">{{ users.rang_name }}</p>
                      </div>
                      <div class="ml-2">
                        <p class="grey--text mb-0">ระดับ</p>
                        <p class="mb-0">{{ users.rang_level }}</p>
                      </div>
                      <div class="ml-2">
                        <p class="grey--text mb-0">วันที่</p>
                        <p class="mb-0">{{ formatDateToThaiIntl(users.date_rang_level) }}</p>
                      </div>
                    </div>

                    <v-alert
                      dense
                      text
                      color="warning"
                      class="mt-2 mb-3"
                    >
                      <span class="text-caption">
                        * หากไม่เป็นปัจจุบันกรุณาติดต่องานบุคลากร
                      </span>
                    </v-alert>

                    <v-divider class="my-3" />

                    <!-- Teaching License -->
                    <div class="info-item align-start">
                      <v-icon small class="mr-2 grey--text mt-1">mdi-card-account-details</v-icon>
                      <div class="flex-grow-1">
                        <p class="grey--text mb-1">ใบประกอบวิชาชีพครู</p>
                        <p class="mb-2">{{ users.pt_licence }}</p>
                        
                        <div class="d-flex align-center flex-wrap">
                          <v-btn
                            v-if="users.pt_licence_file"
                            icon
                            small
                            color="primary"
                            class="mr-2"
                            @click="viewpdflicenseteach(users.pt_licence_file)"
                          >
                            <v-icon small>mdi-file-pdf-box</v-icon>
                          </v-btn>
                          <v-btn
                            v-if="users.pt_licence_file"
                            icon
                            small
                            color="error"
                            class="mr-2"
                            @click="deletelicenseteach()"
                          >
                            <v-icon small>mdi-delete</v-icon>
                          </v-btn>
                          <v-btn
                            v-else
                            icon
                            small
                            color="warning"
                            class="mr-2"
                            @click="personnelUpdate()"
                          >
                            <v-icon small>mdi-pencil</v-icon>
                          </v-btn>
                          <v-chip
                            v-if="!users.pt_licence_file"
                            small
                            color="warning"
                            text-color="white"
                          >
                            ไม่มีไฟล์
                          </v-chip>
                        </div>

                        <div class="mt-2">
                          <p class="grey--text mb-0">
                            วันออกบัตร: {{ users.pt_ondate | moment("add", "543 years") | moment("D MMM YYYY") }}
                          </p>
                          <p class="mb-0">
                            วันหมดอายุ: {{ users.pt_enddate | moment("add", "543 years") | moment("D MMM YYYY") }}
                            <v-chip
                              v-if="users.Agelicence <= 60"
                              x-small
                              color="error"
                              text-color="white"
                              class="ml-2"
                            >
                              {{ users.Agelicence }} วัน
                            </v-chip>
                            <v-chip
                              v-else-if="users.Agelicence <= 180"
                              x-small
                              color="warning"
                              text-color="white"
                              class="ml-2"
                            >
                              {{ users.Agelicence }} วัน
                            </v-chip>
                            <v-chip
                              v-else-if="users.Agelicence"
                              x-small
                              color="success"
                              text-color="white"
                              class="ml-2"
                            >
                              {{ users.Agelicence }} วัน
                            </v-chip>
                          </p>
                        </div>
                      </div>
                    </div>

                    <v-divider class="my-3" />

                    <!-- Director License -->
                    <div class="info-item align-start">
                      <v-icon small class="mr-2 grey--text mt-1">mdi-shield-account</v-icon>
                      <div class="flex-grow-1">
                        <p class="grey--text mb-1">ใบประกอบวิชาชีพผู้บริหาร</p>
                        <p class="mb-2">{{ users.pt_licencedr }}</p>
                        
                        <div class="d-flex align-center flex-wrap">
                          <v-btn
                            v-if="users.pt_licencedr_file"
                            icon
                            small
                            color="primary"
                            class="mr-2"
                            @click="viewpdflicensedr()"
                          >
                            <v-icon small>mdi-file-pdf-box</v-icon>
                          </v-btn>
                          <v-btn
                            v-if="users.pt_licencedr_file"
                            icon
                            small
                            color="error"
                            class="mr-2"
                            @click="deletelicensedr()"
                          >
                            <v-icon small>mdi-delete</v-icon>
                          </v-btn>
                          <v-btn
                            v-else
                            icon
                            small
                            color="warning"
                            class="mr-2"
                            @click="personnelUpdate()"
                          >
                            <v-icon small>mdi-pencil</v-icon>
                          </v-btn>
                          <v-chip
                            v-if="!users.pt_licencedr_file"
                            small
                            color="warning"
                            text-color="white"
                          >
                            ไม่มีไฟล์
                          </v-chip>
                        </div>

                        <div class="mt-2" v-if="users.pt_licencedr">
                          <v-chip
                            small
                            outlined
                            :color="users.pt_licencedr_type === 'a' ? 'success' : 'info'"
                            class="mb-2"
                          >
                            <v-icon small left>mdi-information</v-icon>
                            {{ users.pt_licencedr_type === 'a' ? 'สำเร็จการศึกษาด้านบริหาร' : 'เทียบประสบการณ์ 10 ปี' }}
                          </v-chip>
                          
                          <p class="grey--text mb-0">
                            วันออกบัตร: {{ users.pt_ondatedr | moment("add", "543 years") | moment("D MMM YYYY") }}
                          </p>
                          <p class="mb-0">
                            วันหมดอายุ: {{ users.pt_enddatedr | moment("add", "543 years") | moment("D MMM YYYY") }}
                            <v-chip
                              v-if="users.Agelicencedr <= 60"
                              x-small
                              color="error"
                              text-color="white"
                              class="ml-2"
                            >
                              {{ users.Agelicencedr }} วัน
                            </v-chip>
                            <v-chip
                              v-else-if="users.Agelicencedr <= 180"
                              x-small
                              color="warning"
                              text-color="white"
                              class="ml-2"
                            >
                              {{ users.Agelicencedr }} วัน
                            </v-chip>
                            <v-chip
                              v-else-if="users.Agelicencedr"
                              x-small
                              color="success"
                              text-color="white"
                              class="ml-2"
                            >
                              {{ users.Agelicencedr }} วัน
                            </v-chip>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-col>

                <!-- Right Column -->
                <v-col cols="12" md="6">
                  <div class="info-section">
                    <!-- ID Card -->
                    <div class="info-item">
                      <v-icon small class="mr-2 grey--text">mdi-card-account-details</v-icon>
                      <div class="flex-grow-1">
                        <p class="grey--text mb-0">รหัสบัตรประชาชน</p>
                        <p class="mb-0">{{ users.id_card }}</p>
                      </div>
                    </div>

                    <v-divider class="my-3" />

                    <!-- Birth and Appointment Date -->
                    <div class="info-item">
                      <v-icon small class="mr-2 grey--text">mdi-calendar</v-icon>
                      <div class="flex-grow-1">
                        <p class="grey--text mb-0">วันเกิด</p>
                        <p class="mb-0">
                          {{ users.brith_day }}/{{ users.brith_month }}/{{ users.brith_year }}
                        </p>
                      </div>
                      <div class="ml-4">
                        <p class="grey--text mb-0">วันบรรจุ</p>
                        <p class="mb-0">
                          {{ users.appoin_day }}/{{ users.appoin_month }}/{{ users.appoin_year }}
                        </p>
                      </div>
                    </div>

                    <v-divider class="my-3" />

                    <!-- Retirement and Phone -->
                    <div class="info-item">
                      <v-icon small class="mr-2 grey--text">mdi-clock-outline</v-icon>
                      <div class="flex-grow-1">
                        <p class="grey--text mb-0">เกษียณ</p>
                        <p class="mb-0">{{ users.retrire_year }}</p>
                      </div>
                      <div class="ml-4">
                        <p class="grey--text mb-0">เบอร์โทร</p>
                        <p class="mb-0">{{ users.tel_p }}</p>
                      </div>
                    </div>

                    <v-divider class="my-3" />

                    <!-- Marital Status and Email -->
                    <div class="info-item">
                      <v-icon small class="mr-2 grey--text">mdi-heart</v-icon>
                      <div class="flex-grow-1">
                        <p class="grey--text mb-0">สถานภาพสมรส</p>
                        <p class="mb-0">{{ marital_status }}</p>
                      </div>
                      <div class="ml-4">
                        <p class="grey--text mb-0">อีเมล</p>
                        <p class="mb-0">{{ users.e_mail }}</p>
                      </div>
                    </div>

                    <v-divider class="my-3" />

                    <!-- Action Buttons -->
                    <div class="d-flex justify-center mt-4">
                      <v-btn
                        outlined
                        color="primary"
                        class="mr-2"
                        @click="personnelUpdate()"
                      >
                        <v-icon left small>mdi-pencil</v-icon>
                        ปรับปรุงข้อมูล
                      </v-btn>
                      <v-btn
                        outlined
                        color="info"
                        :href="'#/user/resume/?id_card=' + users.id_card"
                        target="_blank"
                      >
                        <v-icon left small>mdi-file-document</v-icon>
                        พิมพ์ประวัติ
                      </v-btn>
                    </div>
                  </div>
                </v-col>
              </v-row>

              <!-- Important Notice -->
              <v-alert
                v-if="users.status_appove !== 'wait'"
                dense
                text
                color="warning"
                border="left"
                class="mt-4"
              >
                <p class="mb-1">
                  * ข้อมูลส่วนบุคคลให้ท่านตรวจสอบและแก้ไขเฉพาะบางส่วนที่เกี่ยวข้องกับระบบ
                </p>
                <p class="mb-1">
                  * ข้อมูลที่ผิดพลาด เช่น ชื่อ-นามสกุล แจ้งงานบุคลากรของท่านผ่านช่องทาง Line
                </p>
                <p class="mb-0">
                  * ข้อมูลอื่นๆ เช่น ตำแหน่ง วิทยฐานะ ที่ไม่เป็นปัจจุบันให้รอการปรับปรุงจากส่วนกลาง
                </p>
              </v-alert>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Transfer History Section -->
      <v-row>
        <v-col cols="12">
          <v-card  class="info-card">
            <v-card-title class="d-flex align-center pb-0">
              <v-icon class="mr-2">mdi-history</v-icon>
              <span class="font-weight-medium">ประวัติการยื่นย้าย</span>
            </v-card-title>

            <v-card-text class="pt-4">
              <!-- Teacher Transfer Table -->
              <v-data-table
                v-if="users.user_status === 'teacher' || users.user_status === 'gov_em'"
                :loading="loading"
                :headers="filteredHeaders"
                :items="transference_personnels"
                class="modern-table"
                hide-default-footer
                :items-per-page="-1"
              >
                <template v-slot:item.prints1="{ item }">
                  <v-btn
                    v-if="item.tp_steps === '11'"
                    icon
                    color="primary"
                    :href="users.user_status === 'teacher' ? '#/user/print_info/' + item.tid_ref : '#/user/print_info_govem/?id_ref=' + item.id_ref"
                    target="_blank"
                  >
                    <v-icon>mdi-printer</v-icon>
                  </v-btn>
                  <v-icon v-else color="grey lighten-1">mdi-minus</v-icon>
                </template>

                <template v-slot:item.print_doc_kpi="{ item }">
                  <v-btn
                    v-if="item.tp_steps === '11'"
                    icon
                    color="primary"
                    :href="'#/user/print_doc_kpi/' + item.tid_ref"
                    target="_blank"
                  >
                    <v-icon>mdi-printer</v-icon>
                  </v-btn>
                  <v-icon v-else color="grey lighten-1">mdi-minus</v-icon>
                </template>

                <template v-slot:item.print_14_71_form="{ item }">
                  <v-btn
                    v-if="item.tp_steps === '11'"
                    icon
                    color="primary"
                    :href="'#/user/print_14_71_form/' + item.tid_ref"
                    target="_blank"
                  >
                    <v-icon>mdi-printer</v-icon>
                  </v-btn>
                  <v-icon v-else color="grey lighten-1">mdi-minus</v-icon>
                </template>

                <template v-slot:item.print_14_form="{ item }">
                  <v-btn
                    v-if="item.tp_steps === '11'"
                    icon
                    color="primary"
                    :href="'#/user/print_14_form/' + item.tid_ref"
                    target="_blank">
                    <v-icon>mdi-printer</v-icon>
                  </v-btn>
                  <v-icon v-else color="grey lighten-1">mdi-minus</v-icon>
                </template>
              </v-data-table>

              <!-- Management Transfer Table -->
              <v-data-table
                v-if="users.user_status === 'director' || users.user_status === 'se_director'"
                :loading="loading"
                :headers="headers_manage"
                :items="transference_personnels"
                class="modern-table"
                hide-default-footer
                :items-per-page="-1"
              >
                <template v-slot:item="{ item, index }">
                  <tr>
                    <td class="text-center">{{ index + 1 }}</td>
                    <td class="text-center">{{ item.manage_id_ref }}</td>
                    <td class="text-center">{{ item.id_card }}</td>
                    <td>{{ item.frist_name }}</td>
                    <td>{{ item.last_name }}</td>
                    <td class="text-center">{{ item.manage_time_s }}</td>
                    <td class="text-center">{{ item.manage_year_s }}</td>
                    <td class="text-center">{{ item.manage_age_app_time }}</td>
                    <td class="text-center">{{ item.manage_date_time }}</td>
                    <td class="text-center">
                      <v-chip
                        small
                        :color="item.manage_case_move === 'quality' ? 'info' : item.manage_case_move === 'normal' ? 'primary' : 'warning'"
                      >
                        {{ item.manage_case_move === 'quality' ? 'เพื่อพัฒนา' : item.manage_case_move === 'normal' ? 'ปกติ' : 'กรณีพิเศษ' }}
                      </v-chip>
                    </td>
                    <td class="text-center">
                      <v-btn
                        icon
                        color="primary"
                        :href="item.manage_case_move === 'quality' ? '#/user/print_info_manage_d/?manage_id_ref=' + item.manage_id_ref : '#/user/print_info_manage/?manage_id_ref=' + item.manage_id_ref"
                        target="_blank"
                      >
                        <v-icon>mdi-printer</v-icon>
                      </v-btn>
                    </td>
                    <td class="text-center">
                      <v-chip
                        small
                        :color="item.manage_status_save === 'Save' ? 'success' : 'warning'"
                      >
                        {{ item.manage_status_save === 'Save' ? 'เสนอขอย้าย' : 'บันทึกชั่วคราว' }}
                      </v-chip>
                    </td>
                  </tr>
                </template>
              </v-data-table>

              <!-- 38 Transfer Table -->
              <v-data-table
                v-if="['38', '3801', '3802', '3803'].includes(users.user_status)"
                :loading="loading"
                :headers="headers_38"
                :items="transference_personnels"
                class="modern-table"
                hide-default-footer
                :items-per-page="-1"
              >
                <template v-slot:item="{ item, index }">
                  <tr>
                    <td class="text-center">{{ index + 1 }}</td>
                    <td class="text-center">{{ item.tp_id_ref }}</td>
                    <td class="text-center">{{ item.id_card }}</td>
                    <td>{{ item.frist_name }}</td>
                    <td>{{ item.last_name }}</td>
                    <td class="text-center">{{ item.tp_time_s }}</td>
                    <td class="text-center">{{ item.tp_year_s }}</td>
                    <td class="text-center">{{ item.tp_age_app_time }}</td>
                    <td class="text-center">{{ item.tp_date_time }}</td>
                    <td class="text-center">
                      <v-btn
                        v-if="item.tp_steps === '12'"
                        icon
                        color="primary"
                        :href="'#/user/print_info_38/?tp_id_ref=' + item.tp_id_ref"
                        target="_blank"
                      >
                        <v-icon>mdi-printer</v-icon>
                      </v-btn>
                      <v-chip v-else small color="grey" text-color="white">
                        ไม่พร้อม
                      </v-chip>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- Secondary Director Application History -->
        <v-col cols="12" v-if="users.user_status === 'teacher' || users.user_status === 'S'">
          <v-card  class="info-card">
            <v-card-title class="d-flex align-center pb-0">
              <v-icon class="mr-2">mdi-account-tie</v-icon>
              <span class="font-weight-medium">ประวัติการสมัครรองผู้อำนวยการ</span>
            </v-card-title>

            <v-card-text class="pt-4">
              <v-data-table
                :loading="loading"
                :headers="headersSecDirecApp"
                :items="sedirector_app_idcards"
                class="modern-table"
                hide-default-footer
                :items-per-page="-1"
              >
                <template v-slot:item.sedirector_app_status="{ item }">
                  <v-chip
                    small
                    :color="item.sedirector_app_status === '8' ? 'success' : 'warning'"
                  >
                    {{ item.sedirector_app_status === '8' ? 'บันทึก' : 'ยังไม่ได้บันทึก' }}
                  </v-chip>
                </template>

                <template v-slot:item.sedirector_app_position="{ item }">
                  <v-chip
                    small
                    color="primary"
                    v-if="['teach', 'head', 'director'].includes(item.sedirector_app_position)"
                  >
                    {{ item.sedirector_app_position === 'teach' ? 'ครูผู้สอน' : item.sedirector_app_position === 'head' ? 'หัวหน้างาน' : 'รักษาการรอง ผอ.' }}
                  </v-chip>
                  <v-chip v-else small color="grey">ยังไม่ได้บันทึก</v-chip>
                </template>

                <template v-slot:item.sedirector_app_discipline="{ item }">
                  <v-chip
                    small
                    :color="item.sedirector_app_discipline === 'ever' ? 'error' : 'success'"
                  >
                    {{ item.sedirector_app_discipline === 'ever' ? 'เคยถูกลงโทษ' : 'ไม่เคยถูกลงโทษ' }}
                  </v-chip>
                </template>

                <template v-slot:item.sedirector_app_time="{ item }">
                  <span class="">
                    {{ item.sedirector_app_time }}/{{ item.sedirector_app_year }}
                  </span>
                </template>

                <template v-slot:item.sedirector_app_file="{ item }">
                  <div v-if="item.sedirector_app_file && item.sedirector_app_status > 7">
                    <v-icon
                      v-if="item.sedirector_app_file_cc === 'cc'"
                      small
                      color="error"
                    >
                      mdi-alert-circle
                    </v-icon>
                    <v-btn icon small color="success">
                      <v-icon small>mdi-check-circle</v-icon>
                    </v-btn>
                  </div>
                  <v-chip v-else x-small color="grey">ไม่มีไฟล์</v-chip>
                </template>

                <template v-slot:item.sedirector_app_file_A="{ item }">
                  <div v-if="item.sedirector_app_file_A && item.sedirector_app_status > 7">
                    <v-icon
                      v-if="item.sedirector_app_file_A_CC === 'cc'"
                      small
                      color="error"
                    >
                      mdi-alert-circle
                    </v-icon>
                    <v-btn icon small color="success">
                      <v-icon small>mdi-check-circle</v-icon>
                    </v-btn>
                  </div>
                  <v-chip v-else x-small color="grey">ไม่มีไฟล์</v-chip>
                </template>

                <template v-slot:item.sedirector_app_file_B="{ item }">
                  <div v-if="item.sedirector_app_file_B && item.sedirector_app_status > 7">
                    <v-icon
                      v-if="item.sedirector_app_file_B_CC === 'cc'"
                      small
                      color="error"
                    >
                      mdi-alert-circle
                    </v-icon>
                    <v-btn icon small color="success">
                      <v-icon small>mdi-check-circle</v-icon>
                    </v-btn>
                  </div>
                  <v-chip v-else x-small color="grey">ไม่มีไฟล์</v-chip>
                </template>

                <template v-slot:item.sedirector_app_datetime="{ item }">
                  <div v-if="item.sedirector_app_status <= 7">
                    <v-chip x-small color="warning">
                      ทำรายการไม่สำเร็จ
                    </v-chip>
                  </div>
                  <span v-else class="text-caption">
                    {{ item.sedirector_app_datetime | moment("add", "543 years") | moment("D MMM YYYY HH:mm") }}
                  </span>
                </template>

                <template v-slot:item.sedirector_app_pvc_approve="{ item }">
                  <div v-if="item.sedirector_app_status > 7">
                    <v-chip
                      v-if="item.sedirector_app_pvc_approve === 'pass'"
                      small
                      color="success"
                    >
                      <v-icon small left>mdi-check</v-icon>
                      ผ่าน
                    </v-chip>
                    <v-chip
                      v-else-if="item.sedirector_app_pvc_approve === 'fail'"
                      small
                      color="error"
                    >
                      <v-icon small left>mdi-close</v-icon>
                      ไม่ผ่าน
                    </v-chip>
                    <v-chip
                      v-else-if="item.sedirector_app_pvc_approve === 'CC'"
                      small
                      color="warning"
                    >
                      <v-icon small left>mdi-cancel</v-icon>
                      ยกเลิก
                    </v-chip>
                    <v-chip v-else small color="grey lighten-2">
                      รอพิจารณา
                    </v-chip>
                  </div>
                  <v-chip v-else small color="grey">ยังไม่ได้บันทึก</v-chip>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- Timeline Section -->
        <v-col cols="12" v-if="checksedirector_app_idrefs === 'true'">
          <sedirectorAppTimeline />
        </v-col>
      </v-row>
    </v-container>

    <!-- Dialogs -->
    <!-- Personnel Update Dialog -->
    <v-dialog v-model="addpersonneldialog" persistent max-width="900px" scrollable>
      <v-card>
        <v-card-title class="dialog-header">
          <v-icon class="mr-2">mdi-account-edit</v-icon>
          <span class="font-weight-medium">แก้ไขข้อมูลเบื้องต้น</span>
          <v-spacer />
          <v-btn icon @click="addpersonneldialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider />

        <v-card-text class="pa-6">
          <v-form ref="personnelform" lazy-validation>
            <!-- Spouse Information -->
            <div class="form-section">
              <h4 class=" font-weight-medium mb-4">
                <v-icon small class="mr-2">mdi-account-multiple</v-icon>
                ข้อมูลคู่สมรส
              </h4>

              <v-row>
                <v-col cols="12" md="6">
                  <v-select
                    outlined
                    dense
                    label="สถานภาพสมรส"
                    :items="user_marital_status"
                    item-text="title"
                    item-value="value"
                    v-model="users.marital_status"
                  />
                </v-col>

                <template v-if="['married', 'separate'].includes(users.marital_status)">
                  <v-col cols="12" md="6">
                    <v-text-field
                      outlined
                      dense
                      label="รหัสบัตรประชาชนคู่สมรส"
                      v-model="users.id_card_m"
                      :rules="[v => !!v || 'กรุณากรอกข้อมูล']"
                    />
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-text-field
                      outlined
                      dense
                      label="คำนำหน้าชื่อ"
                      v-model="users.title_sm"
                      :rules="[v => !!v || 'กรุณากรอกข้อมูล']"
                    />
                  </v-col>
                  <v-col cols="12" md="5">
                    <v-text-field
                      outlined
                      dense
                      label="ชื่อ"
                      v-model="users.frist_namem"
                      :rules="[v => !!v || 'กรุณากรอกข้อมูล']"
                    />
                  </v-col>
                  <v-col cols="12" md="5">
                    <v-text-field
                      outlined
                      dense
                      label="นามสกุล"
                      v-model="users.last_namem"
                      :rules="[v => !!v || 'กรุณากรอกข้อมูล']"
                    />
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      outlined
                      dense
                      label="อาชีพ"
                      v-model="users.occupation_sm"
                      :rules="[v => !!v || 'กรุณากรอกข้อมูล']"
                    />
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      outlined
                      dense
                      label="สถานที่ทำงาน"
                      v-model="users.work_placem"
                      :rules="[v => !!v || 'กรุณากรอกข้อมูล']"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-autocomplete
                      outlined
                      dense
                      :items="provices_sh"
                      item-text="province_name"
                      item-value="province_ID"
                      label="ภูมิลำเนาของคู่สมรส (จังหวัด)"
                      v-model="users.province_IDm"
                      :rules="[v => !!v || 'กรุณาเลือกจังหวัด']"
                    />
                  </v-col>
                </template>
              </v-row>
            </div>

            <v-divider class="my-6" />

            <!-- Current Address -->
            <div class="form-section">
              <h4 class=" font-weight-medium mb-4">
                <v-icon small class="mr-2">mdi-home</v-icon>
                ที่อยู่ปัจจุบัน
              </h4>

              <v-row>
                <v-col cols="12" md="3">
                  <v-text-field
                    outlined
                    dense
                    label="บ้านเลขที่"
                    v-model="users.pt_homeid"
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    outlined
                    dense
                    label="หมู่ที่"
                    v-model="users.pt_moo"
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    outlined
                    dense
                    label="ถนน"
                    v-model="users.pt_road"
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <v-autocomplete
                    outlined
                    dense
                    :items="provices_sh"
                    item-text="province_name"
                    item-value="province_ID"
                    label="จังหวัด"
                    v-model="users.domicile_pt"
                    :rules="[v => !!v || 'กรุณาเลือกจังหวัด']"
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <v-autocomplete
                    outlined
                    dense
                    :items="prefectures"
                    item-text="prefecture_name"
                    item-value="prefecture_ID"
                    label="อำเภอ"
                    v-model="users.pt_perfecture"
                    :rules="[v => !!v || 'กรุณาเลือกอำเภอ']"
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <v-autocomplete
                    outlined
                    dense
                    :items="district"
                    item-text="district_name"
                    item-value="district_ID"
                    label="ตำบล"
                    v-model="users.pt_distirict"
                    :rules="[v => !!v || 'กรุณาเลือกตำบล']"
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    outlined
                    dense
                    label="เบอร์โทรติดต่อ"
                    v-model="users.tel_p"
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    outlined
                    dense
                    label="อีเมล"
                    v-model="users.e_mail"
                    type="email"
                  />
                </v-col>
              </v-row>
            </div>

            <v-divider class="my-6" />

            <!-- Teaching License -->
            <div class="form-section">
              <h4 class=" font-weight-medium mb-4">
                <v-icon small class="mr-2">mdi-certificate</v-icon>
                ใบอนุญาตประกอบวิชาชีพครู
              </h4>

              <v-radio-group
                v-if="users.type_positition === 'ครูผู้ช่วย'"
                v-model="manage_assistant_teachers.mt_license_status"
                row
                class="mb-4"
              >
                <template v-slot:label>
                  <span class="font-weight-medium mr-4">สถานะใบอนุญาต:</span>
                </template>
                <v-radio value="have" label="มีใบประกอบวิชาชีพครู" />
                <v-radio value="donot" label="ไม่มีใบประกอบวิชาชีพ" />
              </v-radio-group>

              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    outlined
                    dense
                    label="เลขที่ใบอนุญาต"
                    v-model="users.pt_licence"
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    outlined
                    dense
                    type="date"
                    label="วันที่ออกบัตร"
                    v-model="users.pt_ondate"
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    outlined
                    dense
                    type="date"
                    label="วันหมดอายุ"
                    v-model="users.pt_enddate"
                  />
                </v-col>
                <v-col cols="12">
                  <div v-if="users.pt_licence_file" class="d-flex align-center">
                    <v-chip small color="success" class="mr-2">
                      <v-icon small left>mdi-check</v-icon>
                      มีไฟล์แนบแล้ว
                    </v-chip>
                    <v-btn
                      icon
                      small
                      color="primary"
                      class="mr-2"
                      @click="viewpdflicenseteach(users.pt_licence_file)"
                    >
                      <v-icon small>mdi-eye</v-icon>
                    </v-btn>
                    <v-btn
                      icon
                      small
                      color="error"
                      @click="deletelicenseteach()"
                    >
                      <v-icon small>mdi-delete</v-icon>
                    </v-btn>
                    <span class="ml-2">ลบไฟล์เดิมเพื่ออัปโหลดใหม่</span>
                  </div>
                  <v-file-input
                    v-else
                    v-model="license_file"
                    outlined
                    dense
                    accept=".pdf"
                    label="แนบไฟล์ใบอนุญาต (.pdf)"
                    prepend-icon=""
                    prepend-inner-icon="mdi-paperclip"
                    :rules="rules"
                    show-size
                  />
                </v-col>
              </v-row>

              <!-- Temporary Teaching License (for Assistant Teachers) -->
              <template v-if="manage_assistant_teachers.mt_license_status === 'donot'">
                <v-divider class="my-4" />
                <h5 class="text-subtitle-2 font-weight-medium mb-3">ใบอนุญาตปฏิบัติการสอน</h5>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field
                      outlined
                      dense
                      label="เลขที่ใบอนุญาตปฏิบัติการสอน"
                      v-model="manage_assistant_teachers.pt_licence_tem"
                    />
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      outlined
                      dense
                      type="date"
                      label="วันที่ออกบัตร"
                      v-model="manage_assistant_teachers.pt_ondate_tem"
                    />
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      outlined
                      dense
                      type="date"
                      label="วันหมดอายุ"
                      v-model="manage_assistant_teachers.pt_enddate_tem"
                    />
                  </v-col>
                  <v-col cols="12">
                    <div v-if="manage_assistant_teachers.pt_licence_file_tem" class="d-flex align-center">
                      <v-chip small color="success" class="mr-2">
                        <v-icon small left>mdi-check</v-icon>
                        มีไฟล์แนบแล้ว
                      </v-chip>
                      <v-btn
                        icon
                        small
                        color="primary"
                        class="mr-2"
                        @click="viewpdflicenseteach(manage_assistant_teachers.pt_licence_file_tem)"
                      >
                        <v-icon small>mdi-eye</v-icon>
                      </v-btn>
                      <v-btn
                        icon
                        small
                        color="error"
                        @click="deletelicenseteachtem()"
                      >
                        <v-icon small>mdi-delete</v-icon>
                      </v-btn>
                    </div>
                    <v-file-input
                      v-else
                      v-model="pt_licence_file_tem"
                      outlined
                      dense
                      accept=".pdf"
                      label="แนบไฟล์ใบอนุญาตปฏิบัติการสอน (.pdf)"
                      prepend-icon=""
                      prepend-inner-icon="mdi-paperclip"
                      :rules="rules"
                      show-size
                    />
                  </v-col>
                </v-row>
              </template>
            </div>

            <v-divider class="my-6" />

            <!-- Director License -->
            <div class="form-section">
              <h4 class=" font-weight-medium mb-4">
                <v-icon small class="mr-2">mdi-shield-account</v-icon>
                ใบอนุญาตประกอบวิชาชีพผู้บริหาร
              </h4>

              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    outlined
                    dense
                    label="เลขที่ใบอนุญาต"
                    v-model="users.pt_licencedr"
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    outlined
                    dense
                    type="date"
                    label="วันที่ออกบัตร"
                    v-model="users.pt_ondatedr"
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    outlined
                    dense
                    type="date"
                    label="วันหมดอายุ"
                    v-model="users.pt_enddatedr"
                  />
                </v-col>
                <v-col cols="12">
                  <div v-if="users.pt_licencedr_file" class="d-flex align-center">
                    <v-chip small color="success" class="mr-2">
                      <v-icon small left>mdi-check</v-icon>
                      มีไฟล์แนบแล้ว
                    </v-chip>
                    <v-btn
                      icon
                      small
                      color="primary"
                      class="mr-2"
                      @click="viewpdflicensedr()"
                    >
                      <v-icon small>mdi-eye</v-icon>
                    </v-btn>
                    <v-btn
                      icon
                      small
                      color="error"
                      @click="deletelicensedr()"
                    >
                      <v-icon small>mdi-delete</v-icon>
                    </v-btn>
                  </div>
                  <v-file-input
                    v-else
                    v-model="license_filedr"
                    outlined
                    dense
                    accept=".pdf"
                    label="แนบไฟล์ใบอนุญาต (.pdf)"
                    prepend-icon=""
                    prepend-inner-icon="mdi-paperclip"
                    :rules="rules"
                    show-size
                  />
                </v-col>
                <v-col cols="12" v-if="users.pt_licencedr">
                  <v-radio-group
                    v-model="users.pt_licencedr_type"
                    row
                    :rules="[v => !!v || 'กรุณาเลือก']"
                  >
                    <template v-slot:label>
                      <span class="font-weight-medium mr-4">การได้มาซึ่งใบอนุญาต:</span>
                    </template>
                    <v-radio value="a" label="สำเร็จการศึกษาด้านบริหารการศึกษา" />
                    <v-radio value="b" label="เทียบประสบการณ์ไม่น้อยกว่า 10 ปี" />
                  </v-radio-group>
                </v-col>
              </v-row>
            </div>

            <v-divider class="my-6" />

            <!-- Education Information -->
            <div class="form-section">
              <h4 class=" font-weight-medium mb-4">
                <v-icon small class="mr-2">mdi-school</v-icon>
                วุฒิการศึกษา
              </h4>

              <v-row>
                <v-col cols="12">
                  <v-text-field
                    outlined
                    dense
                    label="สถาบันการศึกษาที่จบ"
                    v-model="users.ed_university"
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    outlined
                    dense
                    type="date"
                    label="วันที่เริ่มศึกษา"
                    v-model="users.ed_university_datebegin"
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    outlined
                    dense
                    type="date"
                    label="วันที่จบการศึกษา"
                    v-model="users.ed_university_dateend"
                  />
                </v-col>
              </v-row>
            </div>

            <v-alert
              dense
              text
              color="info"
              border="left"
              class="mt-4"
            >
              <span class="text-caption">
                * การลบใบอนุญาตประกอบวิชาชีพเดิม เพื่อทำการแนบไฟล์ใหม่
              </span>
            </v-alert>
          </v-form>
        </v-card-text>

        <v-divider />

        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn
            text
            @click="addpersonneldialog = false"
          >
            <v-icon left small>mdi-close</v-icon>
            ยกเลิก
          </v-btn>
          <v-btn
            color="primary"
            elevation="0"
            @click="personnelSubmit()"
          >
            <v-icon left small>mdi-content-save</v-icon>
            บันทึกข้อมูล
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Password Update Dialog -->
    <v-dialog v-model="passwoorddialog" persistent max-width="500px">
      <v-card>
        <v-card-title class="dialog-header">
          <v-icon class="mr-2">mdi-lock-reset</v-icon>
          <span class="font-weight-medium">แก้ไขรหัสผ่าน</span>
          <v-spacer />
          <v-btn icon @click="passwoorddialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider />

        <v-card-text class="pa-6">
          <v-form ref="passwordform" lazy-validation>
            <v-text-field
              outlined
              dense
              label="รหัสผ่านใหม่ (อย่างน้อย 8 ตัวอักษร)"
              v-model="users.p_word"
              type="password"
              :rules="[
                v => !!v || 'กรุณากรอกรหัสผ่าน',
                v => (v && v.length >= 8) || 'รหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษร'
              ]"
              prepend-inner-icon="mdi-lock"
              class="mb-2"
            />
            <v-text-field
              outlined
              dense
              label="ยืนยันรหัสผ่าน"
              v-model="users.user_confirmpassword"
              type="password"
              :rules="[
                v => !!v || 'กรุณายืนยันรหัสผ่าน',
                v => v === users.p_word || 'รหัสผ่านไม่ตรงกัน'
              ]"
              prepend-inner-icon="mdi-lock-check"
            />
          </v-form>
        </v-card-text>

        <v-divider />

        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn
            text
            @click="passwoorddialog = false"
          >
            <v-icon left small>mdi-close</v-icon>
            ยกเลิก
          </v-btn>
          <v-btn
            color="primary"
            elevation="0"
            @click="passwordSubmit()"
          >
            <v-icon left small>mdi-content-save</v-icon>
            บันทึก
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Permission Dialog -->
    <v-dialog v-model="permitdialog" persistent max-width="500px">
      <v-card>
        <v-card-title class="dialog-header">
          <v-icon class="mr-2">mdi-shield-lock</v-icon>
          <span class="font-weight-medium">จัดการสิทธิ์การเข้าถึง</span>
          <v-spacer />
          <v-btn icon @click="permitdialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider />

        <v-card-text class="pa-6">
          <v-form ref="permitform" lazy-validation>
            <v-text-field
              outlined
              dense
              label="ยืนยันรหัสผ่าน"
              v-model="users.user_confirmpassword"
              :rules="[v => !!v || 'กรุณากรอกรหัสผ่าน']"
              :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
              :type="show1 ? 'text' : 'password'"
              @click:append="show1 = !show1"
              prepend-inner-icon="mdi-lock"
              class="mb-4"
            />

            <v-radio-group
              v-if="users.user_confirmpassword"
              v-model="users.personnel_etc_pass_api_aw"
              class="mt-2"
            >
              <template v-slot:label>
                <span class="font-weight-medium">กำหนดการเข้าถึงข้อมูล:</span>
              </template>
              <v-radio value="1">
                <template v-slot:label>
                  <div class="d-flex align-center">
                    <v-icon color="success" class="mr-2">mdi-check-circle</v-icon>
                    <span class="success--text font-weight-medium">อนุญาต</span>
                  </div>
                </template>
              </v-radio>
              <v-radio value="0">
                <template v-slot:label>
                  <div class="d-flex align-center">
                    <v-icon color="error" class="mr-2">mdi-close-circle</v-icon>
                    <span class="error--text font-weight-medium">ไม่อนุญาต</span>
                  </div>
                </template>
              </v-radio>
            </v-radio-group>
          </v-form>
        </v-card-text>

        <v-divider />

        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn
            text
            @click="permitdialog = false"
          >
            <v-icon left small>mdi-close</v-icon>
            ยกเลิก
          </v-btn>
          <v-btn
            color="primary"
            elevation="0"
            @click="permitSubmit()"
          >
            <v-icon left small>mdi-content-save</v-icon>
            บันทึก
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Profile Picture Update Dialog -->
    <v-dialog v-model="personnel_temporary_pic_dialog" persistent max-width="500px">
      <v-card>
        <v-card-title class="dialog-header">
          <v-icon class="mr-2">mdi-image-edit</v-icon>
          <span class="font-weight-medium">แก้ไขรูปโปรไฟล์</span>
          <v-spacer />
          <v-btn icon @click="personnel_temporary_pic_dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider />

        <v-card-text class="pa-6">
          <v-form ref="form5" lazy-validation>
            <v-file-input
              v-model="imageFiles"
              outlined
              dense
              accept="image/png, image/jpeg, image/jpg"
              label="เลือกไฟล์รูปภาพ (PNG, JPEG, JPG)"
              prepend-icon=""
              prepend-inner-icon="mdi-camera"
              show-size
              :rules="[
                v => !v || v.size < 5242880 || 'ไฟล์ต้องมีขนาดไม่เกิน 5 MB'
              ]"
            >
              <template v-slot:selection="{ text }">
                <v-chip small color="primary" text-color="white">
                  {{ text }}
                </v-chip>
              </template>
            </v-file-input>

            <v-alert
              dense
              text
              color="info"
              border="left"
              class="mt-4"
            >
              <span class="text-caption">
                * รองรับไฟล์ประเภท PNG, JPEG, JPG เท่านั้น<br>
                * ขนาดไฟล์ไม่เกิน 5 MB
              </span>
            </v-alert>
          </v-form>
        </v-card-text>

        <v-divider />

        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn
            text
            @click="personnel_temporary_pic_dialog = false"
          >
            <v-icon left small>mdi-close</v-icon>
            ยกเลิก
          </v-btn>
          <v-btn
            color="primary"
            elevation="0"
            @click="editpersonnel_temporaryinfoSubmit()"
          >
            <v-icon left small>mdi-upload</v-icon>
            อัปโหลด
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Delete Profile Picture Dialog -->
    <v-dialog v-model="deletefiledialog" persistent max-width="400px">
      <v-card>
        <v-card-title class="dialog-header error white--text">
          <v-icon color="white" class="mr-2">mdi-delete-alert</v-icon>
          <span class="font-weight-medium">ยืนยันการลบ</span>
        </v-card-title>

        <v-divider />

        <v-card-text class="pa-6 text-center">
          <v-icon size="64" color="error" class="mb-4">mdi-alert-circle-outline</v-icon>
          <p class="text-body-1 mb-2">คุณต้องการลบรูปโปรไฟล์นี้หรือไม่?</p>
          <p class="grey--text">{{ users.personnel_temporary_pic }}</p>
        </v-card-text>

        <v-divider />

        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn
            text
            @click="deletefiledialog = false"
          >
            <v-icon left small>mdi-close</v-icon>
            ยกเลิก
          </v-btn>
          <v-btn
            color="error"
            elevation="0"
            @click="deletefileSubmit2()"
          >
            <v-icon left small>mdi-delete</v-icon>
            ลบ
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- PDF Viewer Dialog - Teaching License -->
    <v-dialog v-model="pdflicenseteachdialog" max-width="900px">
      <v-card>
        <v-card-title class="dialog-header">
          <v-icon class="mr-2">mdi-file-pdf-box</v-icon>
          <span class="font-weight-medium">ใบอนุญาตประกอบวิชาชีพครู</span>
          <v-spacer />
          <v-btn icon @click="pdflicenseteachdialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <embed
          :src="'/HRvecLicenseTeach/' + licensefiles"
          width="100%"
          height="700px"
          type="application/pdf"
        />
      </v-card>
    </v-dialog>

    <!-- PDF Viewer Dialog - Director License -->
    <v-dialog v-model="pdflicensedrdialog" max-width="900px">
      <v-card>
        <v-card-title class="dialog-header">
          <v-icon class="mr-2">mdi-file-pdf-box</v-icon>
          <span class="font-weight-medium">ใบอนุญาตประกอบวิชาชีพผู้บริหาร</span>
          <v-spacer />
          <v-btn icon @click="pdflicensedrdialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <embed
          :src="'/HRvecLicenseDirector/' + users.pt_licencedr_file"
          width="100%"
          height="700px"
          type="application/pdf"
        />
      </v-card>
    </v-dialog>

    <!-- Snackbar -->
    <v-snackbar
      v-model="snackbar.show"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      top
      rounded="pill"
    >
      <div class="d-flex align-center">
        <v-icon class="mr-2">{{ snackbar.icon }}</v-icon>
        <span>{{ snackbar.text }}</span>
      </div>
      <template v-slot:action="{ attrs }">
        <v-btn
          text
          v-bind="attrs"
          @click="snackbar.show = false"
        >
          ปิด
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import FlipCountdown from "vue2-flip-countdown";
import sedirectorAppTimeline from "../../components/user/sedirectorAppTimeline";
import User_Alert from "../../components/user/user_Alert.vue";

export default {
  components: { FlipCountdown, sedirectorAppTimeline, User_Alert },
  
  data() {
    return {
      loading: true,
      ApiKey: "HRvec2021",
      
      // Dialog states
      addpersonneldialog: false,
      personnel_temporary_pic_dialog: false,
      VideoDialogYoutube: false,
      deletefiledialog: false,
      passwoorddialog: false,
      pdflicenseteachdialog: false,
      pdflicensedrdialog: false,
      permitdialog: false,
      
      // Data arrays
      transference_personnels: [],
      provices_sh: [],
      prefectures: [],
      district: [],
      sedirector_app_idcards: [],
      
      // Data objects
      users: {},
      users_etc: {},
      periods: {},
      periods_38: {},
      periodsmanage_sedi: {},
      periodsmanage_di: {},
      periods_govem: {},
      period_sedirectors: {},
      period_sedirectorsprocess: {},
      period_directors: {},
      period_directorsprocess: {},
      sedirector_apps: {},
      director_apps: {},
      manage_assistant_teachers: {},
      
      // UI states
      show1: false,
      valid: true,
      checksedirector_app_idrefs: [],
      licensefiles: "",
      
      // File uploads
      imageFiles: null,
      license_file: null,
      license_filedr: null,
      pt_licence_file_tem: null,
      
      // Snackbar config
      snackbar: {
        show: false,
        color: "",
        timeout: 5000,
        icon: "",
        text: ""
      },
      
      // Dropdown options
      user_marital_status: [
        { title: "โสด", value: "single" },
        { title: "สมรส", value: "married" },
        { title: "หม้าย", value: "widow" },
        { title: "หย่า", value: "divorce" },
        { title: "แยกกันอยู่", value: "separate" }
      ],
      
      // Table headers
      headers_teach: [
        { text: "อ้างอิง", align: "center", value: "tid_ref" },
        { text: "รหัสบัตรประชาชน", align: "center", value: "id_card" },
        { text: "ชื่อ", align: "center", value: "frist_name" },
        { text: "นามสกุล", align: "center", value: "last_name" },
        { text: "ครั้งที่", align: "center", value: "time_ss" },
        { text: "ปีที่", align: "center", value: "year_ss" },
        { text: "อายุงาน ณ ปัจจุบัน", align: "center", value: "age_app_time" },
        { text: "วันที่ทำรายการ", align: "center", value: "date_time" },
        { text: "พิมพ์ แบบคำร้อง", align: "center", value: "prints1" },
        { text: "พิมพ์ เอกสารชุดที่ 1", align: "center", value: "print_doc_kpi" },
        { text: "พิมพ์ เอกสาร(7.1)", align: "center", value: "print_14_71_form" },
        { text: "พิมพ์ เอกสาร(7.2)", align: "center", value: "print_14_form" }
      ],

      headers_38: [
        { text: "#", align: "center", value: "index" },
        { text: "อ้างอิง", align: "center", value: "tid_ref" },
        { text: "รหัสบัตรประชาชน", align: "center", value: "id_card" },
        { text: "ชื่อ", align: "center", value: "frist_name" },
        { text: "นามสกุล", align: "center", value: "last_name" },
        { text: "ครั้งที่", align: "center", value: "time_ss" },
        { text: "ปีที่", align: "center", value: "year_ss" },
        { text: "อายุงาน ณ ปัจจุบัน", align: "center", value: "age_app_time" },
        { text: "วันที่ทำรายการ", align: "center", value: "date_time" },
        { text: "พิมพ์ แบบคำร้อง", align: "center", value: "prints1" }
      ],

      headers_manage: [
        { text: "#", align: "center", value: "index" },
        { text: "อ้างอิง", align: "center", value: "manage_id_ref" },
        { text: "รหัสบัตรประชาชน", align: "center", value: "manage_id_card" },
        { text: "ชื่อ", align: "center", value: "frist_name" },
        { text: "นามสกุล", align: "center", value: "last_name" },
        { text: "ครั้งที่", align: "center", value: "manage_time_s" },
        { text: "ปีที่", align: "center", value: "manage_year_s" },
        { text: "อายุงาน ณ ปัจจุบัน", align: "center", value: "manage_age_app_time" },
        { text: "วันที่ทำรายการ", align: "center", value: "manage_date_time" },
        { text: "กรณี", align: "center", value: "manage_case_move" },
        { text: "พิมพ์", align: "center", value: "prints" },
        { text: "สถานะ", align: "center", value: "manage_status_save" }
      ],

      headersSecDirecApp: [
        { text: "รหัสบัตรประชาชน", align: "center", value: "sedirector_app_idcard" },
        { text: "สถานะ", align: "center", value: "sedirector_app_status" },
        { text: "ชื่อ-นามสกุล", align: "left", value: "fristnames" },
        { text: "สถานศึกษาปัจจุบัน", align: "left", value: "user_firstname" },
        { text: "เลขที่ตำแหน่งเดิม", align: "left", value: "id_position" },
        { text: "ครั้งที่/ปี", align: "center", value: "sedirector_app_time" },
        { text: "อายุงาน ณ ปัจจุบัน", align: "center", value: "sedirector_app_agework" },
        { text: "ตำแหน่งที่ใช้สมัคร", align: "center", value: "sedirector_app_position" },
        { text: "วินัย", align: "center", value: "sedirector_app_discipline" },
        { text: "ใบสมัครและเอกสารประกอบฯ", align: "center", value: "sedirector_app_file" },
        { text: "ภาค ก.", align: "center", value: "sedirector_app_file_A" },
        { text: "ภาค ข.", align: "center", value: "sedirector_app_file_B" },
        { text: "วันที่ทำรายการ", align: "center", value: "sedirector_app_datetime" }
      ],
      
      // Validation rules
      rules: [
        value => !value || value.size < 5242880 || "ไฟล์ไม่เกิน 5 MB / 5120 KB"
      ],
      
      // Date configs
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      labels: {
        days: "วัน",
        hours: "ชั่วโมง",
        minutes: "นาที",
        seconds: "วินาที"
      }
    };
  },

  computed: {
    // Filter headers based on user status
    filteredHeaders() {
      if (this.users.user_status === "gov_em") {
        return this.headers_teach.filter(
          h => !["print_doc_kpi", "print_14_71_form", "print_14_form"].includes(h.value)
        );
      }
      return this.headers_teach;
    },

    // Get marital status text
    marital_status() {
      const statusMap = {
        single: "โสด",
        married: "สมรส",
        widow: "หม้าย",
        divorce: "หย่า",
        separate: "แยกกันอยู่"
      };
      return statusMap[this.users.marital_status] || "ไม่ได้กำหนด";
    },

    // Get timestamp
    time_stamp() {
      return Math.floor(Date.now() / 1000);
    },

    // Calculate government service age in years
    get_gov_Age_year() {
      if (!this.users.date_app_now) return 0;
      
      const today = new Date();
      const startDate = new Date(this.users.date_app_now);
      
      let years = today.getFullYear() - startDate.getFullYear();
      const monthDiff = today.getMonth() - startDate.getMonth();
      
      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < startDate.getDate())) {
        years--;
      }
      
      return years;
    }
  },

  watch: {
    // Watch province changes
    'users.domicile_pt': {
      handler(newVal) {
        if (newVal) {
          this.prefectureQueryAll(newVal);
        }
      }
    },

    // Watch prefecture changes
    'users.pt_perfecture': {
      handler(newVal) {
        if (newVal) {
          this.districtQueryAll(newVal);
        }
      }
    }
  },

  async mounted() {
    await this.initializeData();
  },

  methods: {
    // Initialize all data
    async initializeData() {
      try {
        this.loading = true;
        
        // Load user data first
        await this.personnelQuery();
        await this.personnel_etcQuery();
        
        // Load master data
        await this.loadProvinces();
        
        // Check date and load periods
        await this.date_app_nowCheck();
        await Promise.all([
          this.periodQuery(),
          this.periodGov_emQuery(),
          this.periodManagedirectorQuery(),
          this.periodManageSedirectorQuery(),
          this.period38Query()
        ]);
        
        // Load additional data based on user type
        await this.loadUserSpecificData();
        
      } catch (error) {
        console.error("Error initializing data:", error);
        this.showError("เกิดข้อผิดพลาดในการโหลดข้อมูล");
      } finally {
        this.loading = false;
      }
    },

    // Load provinces
    async loadProvinces() {
      const result = await this.$http.post("province_sh.php", {
        ApiKey: this.ApiKey
      });
      this.provices_sh = result.data;
    },

    // Load user specific data
    async loadUserSpecificData() {
      await Promise.all([
        this.timeCheck(),
        this.period_sedirectorQuery(),
        this.period_sedirectorProcess(),
        this.transference_personnelQueryAll(),
        this.sedirector_app_idcardQuery(),
        this.period_directorQuery(),
        this.period_directorProcess(),
        this.manage_assistant_teacherQuery()
      ]);
    },

    // Format date to Thai
    formatDateToThaiIntl(dateString) {
      if (!dateString) return "";
      
      const date = new Date(dateString);
      const options = {
        year: "numeric",
        month: "long",
        day: "numeric",
        timeZone: "Asia/Bangkok"
      };
      return new Intl.DateTimeFormat("th-TH", options).format(date);
    },

    // Query personnel data
    async personnelQuery() {
      const userSession = JSON.parse(sessionStorage.getItem("user")) || {};
      if (!userSession.id_card) {
        this.$router.push("/login");
        return;
      }

      const result = await this.$http.post("personnel_temporary_new.php", {
        ApiKey: this.ApiKey,
        id_card: userSession.id_card
      });
      this.users = result.data || {};
    },

    // Query personnel etc data
    async personnel_etcQuery() {
      const userSession = JSON.parse(sessionStorage.getItem("user")) || {};
      const result = await this.$http.post("personnel_etc.php", {
        ApiKey: this.ApiKey,
        personnel_etc_id_card: userSession.id_card
      });
      this.users_etc = result.data || {};
    },

    // Check date_app_now
    async date_app_nowCheck() {
      if (!this.users.date_app_now || String(this.users.date_app_now).length < 5) {
        Swal.fire({
          icon: "error",
          title: "ให้งานบุคลากร สถานศึกษาของท่าน ดำเนินการปรับปรุงวันที่ปฏิบัติงานให้เรียบร้อย"
        });
      }
    },

    // Period queries
    async periodQuery() {
      const result = await this.$http.post("period.php", {
        ApiKey: this.ApiKey,
        period_id: "301"
      });
      this.periods = result.data || {};
    },

    async periodGov_emQuery() {
      const result = await this.$http.post("period.php", {
        ApiKey: this.ApiKey,
        period_id: "401"
      });
      this.periods_govem = result.data || {};
    },

    async periodManagedirectorQuery() {
      const result = await this.$http.post("period.php", {
        ApiKey: this.ApiKey,
        period_id: "101"
      });
      this.periodsmanage_di = result.data || {};
    },

    async periodManageSedirectorQuery() {
      const result = await this.$http.post("period.php", {
        ApiKey: this.ApiKey,
        period_id: "201"
      });
      this.periodsmanage_sedi = result.data || {};
    },

    async period38Query() {
      const result = await this.$http.post("period.php", {
        ApiKey: this.ApiKey,
        period_id: "3801"
      });
      this.periods_38 = result.data || {};
    },

    async period_sedirectorQuery() {
      const result = await this.$http.post("period_sedirector.php", {
        ApiKey: this.ApiKey,
        period_sedirector_enable: "1",
        period_sedirector_id: "201"
      });
      this.period_sedirectors = result.data || {};
    },

    async period_directorQuery() {
      const result = await this.$http.post("period_sedirector.php", {
        ApiKey: this.ApiKey,
        period_sedirector_enable: "1",
        period_sedirector_id: "301"
      });
      this.period_directors = result.data || {};
    },

    // Time check and update
    async timeCheck() {
      if (!this.periods.period_stop) return;

      const dateNow = new Date();
      const dateStop = new Date(`${this.periods.period_stop} 16:30:00`);
      
      if (dateNow.getTime() > dateStop.getTime()) {
        await this.periodTeacherUpdate();
      }
    },

    async periodTeacherUpdate() {
      await this.$http.post("period.update.php", {
        ApiKey: this.ApiKey,
        ...this.periods,
        period_enable: "0"
      });
    },

    // Dialog methods
    async personnelUpdate() {
      this.addpersonneldialog = true;
    },

    async personnelPicUpdate() {
      this.personnel_temporary_pic_dialog = true;
    },

    async passwordUpdate() {
      this.users.p_word = "";
      this.users.user_confirmpassword = "";
      this.passwoorddialog = true;
    },

    async permitSystem() {
      this.users.user_confirmpassword = "";
      this.permitdialog = true;
    },

    async personnelPicDelete() {
      this.deletefiledialog = true;
    },

    // View PDF methods
    async viewpdflicenseteach(licensefile) {
      this.licensefiles = licensefile;
      this.pdflicenseteachdialog = true;
    },

    async viewpdflicensedr() {
      this.pdflicensedrdialog = true;
    },

    // Submit methods
    async personnelSubmit() {
      if (!this.$refs.personnelform.validate()) return;

      try {
        this.loading = true;

        // Upload license file if exists
        if (this.license_file) {
          await this.uploadLicenseFile(this.license_file, "teach");
        }

        // Upload director license file if exists
        if (this.license_filedr) {
          await this.uploadLicenseFile(this.license_filedr, "dr");
        }

        // Update personnel data
        const result = await this.$http.post("personnel_temporary.update.php", {
          ApiKey: this.ApiKey,
          ...this.users
        });

        // Update marriage data
        await this.$http.post("personnel_marriage.insert.php", {
          ApiKey: this.ApiKey,
          ...this.users
        });

        // Update assistant teacher data if applicable
        if (this.users.position_name === "ครูผู้ช่วย" && 
            this.manage_assistant_teachers.mt_id_card) {
          await this.updateAssistantTeacher();
        }

        if (result.data.status) {
          this.showSuccess("ดำเนินการแก้ไขข้อมูลเรียบร้อย");
          await this.personnelQuery();
          this.addpersonneldialog = false;
        }
      } catch (error) {
        console.error("Error updating personnel:", error);
        this.showError("เกิดข้อผิดพลาดในการบันทึกข้อมูล");
      } finally {
        this.loading = false;
      }
    },

    async passwordSubmit() {
      if (!this.$refs.passwordform.validate()) return;

      try {
        const result = await this.$http.post(
          "personnel_temporary.update.password.php",
          {
            ApiKey: this.ApiKey,
            id_card: this.users.id_card,
            p_word: this.users.p_word
          }
        );

        if (result.data.status) {
          this.showSuccess("แก้ไขรหัสผ่านเรียบร้อย");
          this.passwoorddialog = false;
          await this.personnelQuery();
        } else {
          this.showError("เกิดข้อผิดพลาดในการแก้ไขรหัสผ่าน");
        }
      } catch (error) {
        console.error("Error updating password:", error);
        this.showError("เกิดข้อผิดพลาดในการแก้ไขรหัสผ่าน");
      }
    },

    async permitSubmit() {
      if (!this.$refs.permitform.validate()) return;

      try {
        // Verify password
        const result_ck = await this.$http.post("login.php?crud=user", {
          ApiKey: this.ApiKey,
          id_card: this.users.id_card,
          p_word: this.users.user_confirmpassword
        });

        if (result_ck.data.user_status === "Fail") {
          this.showError("รหัสผ่านไม่ถูกต้อง");
          return;
        }

        // Update permission
        await this.$http.post("personnel_etc.update.pass.php", {
          ApiKey: this.ApiKey,
          personnel_etc_id_card: this.users.id_card,
          personnel_etc_pass: this.users.user_confirmpassword,
          personnel_etc_pass_api: this.users.user_confirmpassword,
          personnel_etc_pass_api_aw: this.users.personnel_etc_pass_api_aw
        });

        // Update overcci
        await this.$http.post("personnel_etc.update.pass.ovecci.php", {
          personnel_etc_id_card: this.users.id_card
        });

        this.showSuccess("บันทึกการอนุญาตเรียบร้อย");
        await Promise.all([
          this.personnelQuery(),
          this.personnel_etcQuery()
        ]);
        
        this.permitdialog = false;
      } catch (error) {
        console.error("Error updating permission:", error);
        this.showError("เกิดข้อผิดพลาดในการบันทึก");
      }
    },

    async editpersonnel_temporaryinfoSubmit() {
      if (!this.$refs.form5.validate()) return;

      try {
        if (this.imageFiles) {
          const filename = `${this.users.id_card}.${this.time_stamp}.users.jpg`;
          const formData = new FormData();
          formData.append("ApiKey", this.ApiKey);
          formData.append("file", this.imageFiles);
          formData.append("filename", `../HRvecfiles/${filename}`);

          const result = await this.$http.post("uploadfile.php", formData, {
            headers: { "Content-Type": "multipart/form-data" }
          });

          if (result.data.status) {
            this.users.personnel_temporary_pic = filename;
          }
        }

        await this.$http.post("personnel_temporary.update.php", {
          ApiKey: this.ApiKey,
          ...this.users
        });

        this.showSuccess("บันทึกรูปโปรไฟล์เรียบร้อย");
        await this.personnelQuery();
        this.personnel_temporary_pic_dialog = false;
      } catch (error) {
        console.error("Error uploading image:", error);
        this.showError("เกิดข้อผิดพลาดในการอัปโหลดรูปภาพ");
      }
    },

    // Delete methods
    async deletelicenseteach() {
      const confirmed = await this.confirmDelete(
        "ลบไฟล์ใบอนุญาตประกอบวิชาชีพครู"
      );
      if (!confirmed) return;

      try {
        await this.$http.post("deletefile.php", {
          ApiKey: this.ApiKey,
          filename: `../HRvecLicenseTeach/${this.users.pt_licence_file}`
        });

        await this.$http.post("personnel_temporary.update.php", {
          ApiKey: this.ApiKey,
          pt_licence_file: "",
          id_card: this.users.id_card
        });

        this.showSuccess("ลบไฟล์เรียบร้อย");
        await this.personnelQuery();
      } catch (error) {
        console.error("Error deleting file:", error);
        this.showError("เกิดข้อผิดพลาดในการลบไฟล์");
      }
    },

    async deletelicensedr() {
      const confirmed = await this.confirmDelete(
        "ลบไฟล์ใบอนุญาตประกอบวิชาชีพผู้บริหาร"
      );
      if (!confirmed) return;

      try {
        await this.$http.post("deletefile.php", {
          ApiKey: this.ApiKey,
          filename: `../HRvecLicenseDirector/${this.users.pt_licencedr_file}`
        });

        await this.$http.post("personnel_temporary.update.php", {
          ApiKey: this.ApiKey,
          pt_licencedr_file: "",
          id_card: this.users.id_card
        });

        this.showSuccess("ลบไฟล์เรียบร้อย");
        await this.personnelQuery();
      } catch (error) {
        console.error("Error deleting file:", error);
        this.showError("เกิดข้อผิดพลาดในการลบไฟล์");
      }
    },

    async deletelicenseteachtem() {
      const confirmed = await this.confirmDelete(
        "ลบไฟล์ใบอนุญาตปฏิบัติการสอน"
      );
      if (!confirmed) return;

      try {
        await this.$http.post("deletefile.php", {
          ApiKey: this.ApiKey,
          filename: `../HRvecLicenseTeach/${this.manage_assistant_teachers.pt_licence_file_tem}`
        });

        await this.$http.post("manage_assistant_teacher.update.idcard.php", {
          ApiKey: this.ApiKey,
          pt_licence_file_tem: "",
          mt_id_card: this.manage_assistant_teachers.mt_id_card
        });

        this.showSuccess("ลบไฟล์เรียบร้อย");
        await this.manage_assistant_teacherQuery();
      } catch (error) {
        console.error("Error deleting file:", error);
        this.showError("เกิดข้อผิดพลาดในการลบไฟล์");
      }
    },

    async deletefileSubmit2() {
      try {
        await this.$http.post("deletefile.php", {
          ApiKey: this.ApiKey,
          filename: `../HRvecfiles/${this.users.personnel_temporary_pic}`
        });

        await this.$http.post("personnel_temporary.update.php", {
          ApiKey: this.ApiKey,
          personnel_temporary_pic: "",
          id_card: this.users.id_card
        });

        this.showSuccess("ลบรูปโปรไฟล์เรียบร้อย");
        await this.personnelQuery();
        this.deletefiledialog = false;
      } catch (error) {
        console.error("Error deleting file:", error);
        this.showError("เกิดข้อผิดพลาดในการลบรูป");
      }
    },

    // Helper methods
    async uploadLicenseFile(file, type) {
      const filename = `${this.users.id_card}.${this.time_stamp}.${type}.pdf`;
      const formData = new FormData();
      formData.append("ApiKey", this.ApiKey);
      formData.append("file", file);
      formData.append(
        "filename",
        `../HRvecLicense${type === "dr" ? "Director" : "Teach"}/${filename}`
      );

      const result = await this.$http.post("uploadfile.php", formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });

      if (result.data.status) {
        if (type === "teach") {
          this.users.pt_licence_file = filename;
        } else {
          this.users.pt_licencedr_file = filename;
        }
      }
    },

    async updateAssistantTeacher() {
      if (this.pt_licence_file_tem) {
        const filename = `${this.users.id_card}.${this.time_stamp}.teach_tem.pdf`;
        const formData = new FormData();
        formData.append("ApiKey", this.ApiKey);
        formData.append("file", this.pt_licence_file_tem);
        formData.append("filename", `../HRvecLicenseTeach/${filename}`);

        const result = await this.$http.post("uploadfile.php", formData, {
          headers: { "Content-Type": "multipart/form-data" }
        });

        if (result.data.status) {
          this.manage_assistant_teachers.pt_licence_file_tem = filename;
        }
      }

      this.manage_assistant_teachers.pertem_assistantFile = this.users.pertem_assistantFile;

      if (this.manage_assistant_teachers.mt_license_status === "have") {
        Object.assign(this.manage_assistant_teachers, {
          pt_licence: this.users.pt_licence,
          pt_ondate: this.users.pt_ondate,
          pt_enddate: this.users.pt_enddate,
          pt_licence_file: this.users.pt_licence_file
        });
      } else {
        Object.assign(this.manage_assistant_teachers, {
          pt_licence: "",
          pt_ondate: "",
          pt_enddate: "",
          pt_licence_file: ""
        });
      }

      await this.$http.post(
        "manage_assistant_teacher.update.idcard.php",
        {
          ApiKey: this.ApiKey,
          ...this.manage_assistant_teachers
        }
      );
    },

    async prefectureQueryAll(province_ID) {
      const result = await this.$http.post("prefecture.php", { province_ID });
      this.prefectures = result.data || [];
    },

    async districtQueryAll(prefecture_ID) {
      const result = await this.$http.post("districts.php", { prefecture_ID });
      this.district = result.data || [];
    },

    async manage_assistant_teacherQuery() {
      if (this.users.position_name !== "ครูผู้ช่วย") return;

      const result = await this.$http.post("manage_assistant_teacher.php", {
        ApiKey: this.ApiKey,
        mt_id_card: this.users.id_card,
        flash: "ok"
      });
      this.manage_assistant_teachers = result.data || {};
    },

    async sedirector_app_idcardQuery() {
      const result = await this.$http.post("sedirector_app.php", {
        ApiKey: this.ApiKey,
        sedirector_app_idcard: this.users.id_card
      });
      this.sedirector_app_idcards = result.data || [];
    },

    async period_sedirectorProcess() {
      const result = await this.$http.post("period_sedirector.php", {
        ApiKey: this.ApiKey,
        period_sedirector_process: "1",
        period_sedirector_id: "201"
      });
      this.period_sedirectorsprocess = result.data || {};

      if (this.period_sedirectorsprocess.period_sedirector_year) {
        const appResult = await this.$http.post("sedirector_app.php", {
          ApiKey: this.ApiKey,
          sedirector_app_year: this.period_sedirectorsprocess.period_sedirector_year,
          sedirector_app_time: this.period_sedirectorsprocess.period_sedirector_times,
          sedirector_app_idcard: this.users.id_card
        });
        this.sedirector_apps = appResult.data || {};
        
        const checkdata = String(this.sedirector_apps.sedirector_app_idref || "");
        this.checksedirector_app_idrefs = checkdata.length > 10 ? "true" : "false";
      }
    },

    async period_directorProcess() {
      const result = await this.$http.post("period_sedirector.php", {
        ApiKey: this.ApiKey,
        period_sedirector_process: "1",
        period_sedirector_id: "301"
      });
      this.period_directorsprocess = result.data || {};

      if (this.period_directorsprocess.period_sedirector_year) {
        const appResult = await this.$http.post("sedirector_app.php", {
          ApiKey: this.ApiKey,
          sedirector_app_year: this.period_directorsprocess.period_sedirector_year,
          sedirector_app_time: this.period_directorsprocess.period_sedirector_times,
          sedirector_app_idcard: this.users.id_card,
          sedirector_app_ptype: 3
        });
        this.director_apps = appResult.data || {};
        
        const checkdata = String(this.director_apps.sedirector_app_idref || "");
        this.checksedirector_app_idrefs = checkdata.length > 10 ? "true" : "false";
      }
    },

    async transference_personnelQueryAll() {
      let result;
      const userStatus = this.users.user_status;

      switch (userStatus) {
        case "teacher":
        case "gov_em":
          result = await this.$http.post("transference_personnel.php", {
            ApiKey: this.ApiKey,
            id_card: this.users.id_card
          });
          break;

        case "director":
        case "se_director":
          result = await this.$http.post("transference_manage.php", {
            ApiKey: this.ApiKey,
            manage_id_card: this.users.id_card
          });
          break;

        case "38":
        case "3801":
        case "3802":
        case "3803":
          result = await this.$http.post("transference_personnel_38.php", {
            ApiKey: this.ApiKey,
            tp_id_card: this.users.id_card
          });
          break;

        case "S":
          // No action needed
          return;

        default:
          return;
      }

      this.transference_personnels = result.data || [];
    },

    // Video dialog methods
    async VideoDialog() {
      this.VideoDialogYoutube = true;
    },

    async VideoDialogYoutubeStop() {
      const videos = document.querySelectorAll("iframe, video");
      videos.forEach(video => {
        if (video.tagName.toLowerCase() === "video") {
          video.pause();
        } else {
          const src = video.src;
          video.src = src;
        }
      });
      this.VideoDialogYoutube = false;
    },

    // Utility methods
    async confirmDelete(message) {
      const result = await Swal.fire({
        title: "ยืนยันการลบ",
        text: message,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก"
      });
      return result.isConfirmed;
    },

    showSuccess(message) {
      Swal.fire({
        icon: "success",
        title: message,
        showConfirmButton: false,
        timer: 1500
      });
    },

    showError(message) {
      Swal.fire({
        icon: "error",
        title: message,
        showConfirmButton: false,
        timer: 1500
      });
    },

    showWarning(message) {
      Swal.fire({
        icon: "warning",
        title: message,
        showConfirmButton: false,
        timer: 1500
      });
    },

    showSnackbar(text, color = "success", icon = "mdi-check-circle") {
      this.snackbar = {
        show: true,
        text,
        color,
        icon,
        timeout: 5000
      };
    }
  }
};
</script>

<style scoped>
/* ========================================
   Modern Design System
   ======================================== */

/* Color Variables */
:root {
  --primary-color: #1976D2;
  --secondary-color: #424242;
  --success-color: #4CAF50;
  --warning-color: #FF9800;
  --error-color: #F44336;
  --info-color: #2196F3;
  --grey-50: #FAFAFA;
  --grey-100: #F5F5F5;
  --grey-200: #EEEEEE;
  --grey-300: #E0E0E0;
  --grey-600: #757575;
  --grey-800: #424242;
}

/* ========================================
   Layout & Container
   ======================================== */

#user-profile {
  min-height: 100vh;
  background-color: var(--grey-50);
}

.v-container {
  max-width: 1400px;
}

/* ========================================
   Card Styles
   ======================================== */

.profile-card,
.info-card {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  background: white;
  transition: all 0.3s ease;
}

.profile-card:hover,
.info-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}

/* ========================================
   Profile Section
   ======================================== */

.profile-header {
  padding: 32px 24px 24px;
  text-align: center;
}

.profile-avatar-wrapper {
  position: relative;
  display: inline-block;
}

.profile-avatar {
  border: 4px solid white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.delete-pic-btn {
  position: absolute;
  bottom: 8px;
  right: 8px;
  background: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.profile-info h3 {
  color: var(--grey-800);
  line-height: 1.4;
}

.profile-actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

/* ========================================
   Information Display
   ======================================== */

.info-section {
  padding: 4px 0;
}

.info-item {
  display: flex;
  align-items: center;
  padding: 12px 0;
}

.info-item.align-start {
  align-items: flex-start;
}


/* ========================================
   Table Styles
   ======================================== */

.modern-table {
  border-radius: 8px;
  overflow: hidden;
}

.modern-table >>> .v-data-table__wrapper {
  border-radius: 8px;
}

.modern-table >>> thead {
  background-color: var(--grey-100);
}

.modern-table >>> th {
  font-weight: 600 !important;
  color: var(--grey-800) !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid var(--grey-300) !important;
}

.modern-table >>> td {
  color: var(--grey-800);
  padding: 16px !important;
}

.modern-table >>> tbody tr {
  transition: background-color 0.2s ease;
}

.modern-table >>> tbody tr:hover {
  background-color: var(--grey-50) !important;
}

/* ========================================
   Form Section
   ======================================== */

.form-section {
  margin-bottom: 24px;
}

.form-section:last-child {
  margin-bottom: 0;
}

.form-section h4,
.form-section h5 {
  color: var(--grey-800);
  margin-bottom: 16px;
}

/* ========================================
   Dialog Styles
   ======================================== */

.dialog-header {
  background-color: var(--grey-50);
  border-bottom: 1px solid var(--grey-200);
  padding: 20px 24px;
}

.dialog-header.error {
  background-color: var(--error-color);
}

.v-dialog >>> .v-card {
  border-radius: 12px;
  overflow: hidden;
}

.v-dialog >>> .v-card__text {
  max-height: 70vh;
  overflow-y: auto;
}

/* Scrollbar Styling */
.v-dialog >>> .v-card__text::-webkit-scrollbar {
  width: 8px;
}

.v-dialog >>> .v-card__text::-webkit-scrollbar-track {
  background: var(--grey-100);
}

.v-dialog >>> .v-card__text::-webkit-scrollbar-thumb {
  background: var(--grey-300);
  border-radius: 4px;
}

.v-dialog >>> .v-card__text::-webkit-scrollbar-thumb:hover {
  background: var(--grey-600);
}

/* ========================================
   Button Styles
   ======================================== */

.v-btn {
  text-transform: none;
  letter-spacing: 0.25px;
  font-weight: 500;
}

.v-btn--outlined {
  border-width: 1.5px;
}

/* ========================================
   Chip Styles
   ======================================== */

.v-chip {
  font-weight: 500;
  letter-spacing: 0.25px;
}

.v-chip.v-size--small {
  height: 24px;
}

.v-chip.v-size--x-small {
  height: 20px;
}

/* ========================================
   Alert Styles
   ======================================== */

.v-alert {
  border-radius: 8px;
}

.v-alert.v-alert--dense {
  padding: 12px 16px;
}

.v-alert >>> .v-alert__content {
  line-height: 1.5;
}

/* ========================================
   Input & Form Styles
   ======================================== */

.v-text-field--outlined >>> fieldset {
  border-color: var(--grey-300);
  border-width: 1.5px;
}

.v-text-field--outlined:not(.error--text) >>> fieldset:hover {
  border-color: var(--primary-color);
}

.v-select--outlined >>> fieldset,
.v-autocomplete--outlined >>> fieldset {
  border-color: var(--grey-300);
  border-width: 1.5px;
}

.v-file-input >>> fieldset {
  border-color: var(--grey-300);
  border-width: 1.5px;
}

/* ========================================
   Divider Styles
   ======================================== */

.v-divider {
  border-color: var(--grey-200);
}

/* ========================================
   Loading State
   ======================================== */

.v-data-table >>> .v-data-table__progress {
  height: 3px;
}

.v-data-table >>> .v-data-table__progress .v-progress-linear {
  height: 3px;
}

/* ========================================
   Snackbar Styles
   ======================================== */

.v-snackbar >>> .v-snack__wrapper {
  min-width: 300px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
}

.v-snackbar >>> .v-snack__content {
  padding: 16px 24px;
}

/* ========================================
   Responsive Design
   ======================================== */

@media (max-width: 960px) {
  .profile-header {
    padding: 24px 16px 16px;
  }

  .profile-avatar {
    width: 120px !important;
    height: 120px !important;
  }

  .info-item {
    flex-direction: column;
    align-items: flex-start;
  }

  .info-item > div:not(:first-child) {
    margin-left: 0 !important;
    margin-top: 8px;
  }

  .modern-table >>> td {
    padding: 12px 8px !important;
  }

  .dialog-header {
    padding: 16px;
  }

  .v-dialog {
    margin: 16px;
  }
}

@media (max-width: 600px) {
  .v-container {
    padding: 12px;
  }

  .profile-card,
  .info-card {
    border-radius: 8px;
  }

}

/* ========================================
   Print Styles
   ======================================== */

@media print {
  #user-profile {
    background: white;
  }

  .v-btn,
  .v-dialog,
  .v-snackbar,
  .profile-actions,
  .delete-pic-btn {
    display: none !important;
  }

  .profile-card,
  .info-card {
    box-shadow: none;
    border: 1px solid var(--grey-300);
  }

  .modern-table {
    page-break-inside: avoid;
  }
}

/* ========================================
   Accessibility
   ======================================== */

.v-btn:focus,
.v-text-field:focus-within,
.v-select:focus-within {
  outline: 2px solid var(--primary-color);
  outline-offset: 2px;
}

/* High Contrast Mode Support */
@media (prefers-contrast: high) {
  .profile-card,
  .info-card {
    border: 2px solid var(--grey-800);
  }

  .v-btn--outlined {
    border-width: 2px;
  }
}

/* Reduced Motion Support */
@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}

/* ========================================
   Utility Classes
   ======================================== */

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.shadow-sm {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.shadow-md {
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.shadow-lg {
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.12);
}

/* ========================================
   Animation
   ======================================== */

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.v-card {
  animation: fadeIn 0.3s ease-out;
}

/* ========================================
   Dark Mode Support (Optional)
   ======================================== */

@media (prefers-color-scheme: dark) {
  /* Uncomment to enable dark mode */
  /*
  :root {
    --grey-50: #1E1E1E;
    --grey-100: #2D2D2D;
    --grey-200: #3D3D3D;
    --grey-300: #4D4D4D;
    --grey-600: #BDBDBD;
    --grey-800: #E0E0E0;
  }

  #user-profile {
    background-color: var(--grey-50);
  }

  .profile-card,
  .info-card {
    background-color: var(--grey-100);
    color: var(--grey-800);
  }
  */
}
</style>